const spaceTokens = {
  "group.horizontalGap": 16,
  "group.verticalGap": 16
};
export { spaceTokens };
//# sourceMappingURL=Group.tokens.mjs.map
